import { create } from "zustand";
import { Tabs } from "../model/model";
import _ from "lodash";
import { API_URL } from "../constants";
import axios from "axios";

export const useGlobalStateStore = create((set, get) => ({
  mode: "",
  lastLoadedPages: {
    [Tabs.FullTime]: 0,
    [Tabs.FirstHalf]: 0,
    [Tabs.SecondHalf]: 0,
  },
  activeTab: Tabs.FullTime,
  loadingPages: {
    [Tabs.FullTime]: false,
    [Tabs.FirstHalf]: false,
    [Tabs.SecondHalf]: false,
  },
  paginationLoading: false,
  loading: false,
  canLoadMore: true,
  filterOpen: false,
  filter: {
    date: new Date(),
    countries: [],
    league: [],
    bookmakers: [],
    markets: {
      checkBoxWinner: true,
      checkBoxDc: false,
      over_goals: [],
      under_goals: [],
    },
    oddsValue: {
      min: 1,
      max: 10,
      enabled: false,
    },
  },
  selectedBet: null,
  selectedBetPopupDisplayed: false,
  data: {
    [Tabs.FullTime]: [],
    [Tabs.FirstHalf]: [],
    [Tabs.SecondHalf]: [],
  },
  searchQuery: "",
  isSearching: false,

  setMode: (mode) => {
    set({
      mode: mode,
    });
  },

  getMode: () => {
    return get().mode;
  },

  getFilter: () => {
    return get().filter;
  },

  getSearchQuery: () => {
    return get().searchQuery;
  },

  setSearchQuery: (query) => {
    set({ searchQuery: query });
  },

  setIsSearching: (value) => {
    set({ isSearching: value });
  },
  resetFilter: () => {
    set({
      filter: {
        date: new Date(),
        countries: [],
        league: [],
        bookmakers: [],
        markets: {
          checkBoxWinner: true,
          checkBoxDc: false,
          over_goals: [],
          under_goals: [],
        },
        oddsValue: {
          min: 1,
          max: 10,
          enabled: false,
        },
      },
    });
  },

  deactivateSearchMode: () => {
    get().clearOddsData();
    set({
      lastLoadedPages: {
        [Tabs.FullTime]: 0,
        [Tabs.FirstHalf]: 0,
        [Tabs.SecondHalf]: 0,
      },
      searchQuery: "",
      canLoadMore: true,
    });
  },

  updateSearchResults: (searchData) => {
    set({
      data: {
        [Tabs.FullTime]: searchData[Tabs.FullTime] || [],
        [Tabs.FirstHalf]: searchData[Tabs.FirstHalf] || [],
        [Tabs.SecondHalf]: searchData[Tabs.SecondHalf] || [],
      },
      lastLoadedPages: {
        [Tabs.FullTime]: 0,
        [Tabs.FirstHalf]: 0,
        [Tabs.SecondHalf]: 0,
      },
      canLoadMore: false,
    });
  },

  setDate: (value) => {
    set((state) => {
      return {
        filter: {
          ...state.filter,
          date: value,
        },
      };
    });
  },

  setMarketFilter: (marketName, value) => {
    set((state) => {
      return {
        filter: {
          ...state.filter,
          markets: {
            ...state.filter.markets,
            [marketName]: value,
          },
        },
      };
    });
  },

  setCountry: (value) => {
    set((state) => {
      return {
        filter: {
          ...state.filter,
          countries: value,
        },
      };
    });
  },

  setLeague: (value) => {
    set((state) => {
      return {
        filter: {
          ...state.filter,
          league: value,
        },
      };
    });
  },

  setBookmakers: (value) => {
    set((state) => {
      return {
        filter: {
          ...state.filter,
          bookmakers: value,
        },
      };
    });
  },

  setGoals: (nameGoal, value) => {
    set((state) => ({
      filter: {
        ...state.filter,
        markets: {
          ...state.filter.markets,
          [nameGoal]: value,
        },
      },
    }));
  },

  setOdds: (field, value) => {
    set((state) => {
      return {
        filter: {
          ...state.filter,
          oddsValue: {
            ...state.filter.oddsValue,
            [field]: value,
          },
        },
      };
    });
  },

  setFilterOpen: (value) => set({ filterOpen: value }),
  getFilterOpen: () => get().filterOpen,

  clearOddsData: () => {
    set({
      data: {
        [Tabs.FullTime]: [],
        [Tabs.FirstHalf]: [],
        [Tabs.SecondHalf]: [],
      },
    });
  },

  insertOddsData: (tab, newData) => {
    const data = get().data;

    const tabData = data[tab].concat(newData);


    set({
      data: {
        ...data,
        [tab]: tabData,
      },
    });
  },

  // ✅ Updated to be tab-specific
  setLastLoadedPage: (tab, page) => {
    set((state) => ({
      lastLoadedPages: {
        ...state.lastLoadedPages,
        [tab]: page,
      },
    }));
  },

  // ✅ Updated to be tab-specific
  getLastLoadedPage: (tab) => get().lastLoadedPages[tab] || 0,

  setLoadingForTab: (tab, value) => {
    set((state) => ({
      loadingPages: {
        ...state.loadingPages,
        [tab]: value,
      },
    }));
  },

  isLoadingForTab: (tab) => get().loadingPages[tab] || false,

  setPaginationLoading: (value) => {
    set({ paginationLoading: value });
  },

  isPaginationLoading: () => get().paginationLoading,

  setCanLoadMore: (value) => {
    set({
      canLoadMore: value,
    });
  },

  setActiveTab: (tab) => {
    set({ activeTab: tab });
  },

  getActiveTab: () => get().activeTab,

  toggleSelectedBet: (value) => {
    let newValue = value == null ? null : value;

    if (newValue != null) {
      const existingValue = get().selectedBet;
      if (_.isEqual(newValue, existingValue)) {
        newValue = null;
      }
    }

    set({
      selectedBet: newValue,
    });
  },

  getSelectedBet: () => {
    return get().selectedBet;
  },

  displaySelectedBetPopup: () => {
    set({
      selectedBetPopupDisplayed: true,
    });
  },

  hideSelectedBetPopup: () => {
    set({
      selectedBetPopupDisplayed: false,
    });
  },
  clearSelectedBet: () => {
    set({ selectedBet: null });
  },

  setLoading: (value) => {
    set({ loading: value });
  },
  isLoading: () => get().loading,

  log: () => {
    console.log(get());
  },
}));

export const useOddsStore = create((set, get) => {
  let searchTimeout = null;

  return {
    page: 1,
    oddsData: {
      odds1: null,
      odds2: null,
      odds3: null,
    },
    loading: {
      loading1: true,
      loading2: true,
      loading3: true,
    },
    error: {
      error1: null,
      error2: null,
      error3: null,
    },
    sort: {
      status: "default",
    },
    searchQuery: "",
    baseUrl: "",

    setBaseUrl: (newUrl) => {
      set({ baseUrl: newUrl });
    },

    setSort: (status) => {
      set((state) => ({
        sort: { ...state.sort, status },
      }));
    },

    appendOddsData: (oddsKey, newData) => {
      set((state) => ({
        oddsData: {
          ...state.oddsData,
          [oddsKey]: [...(state.oddsData[oddsKey] || []), ...newData],
        },
      }));
    },

    setSearchQuery: (query) => {
      set({ searchQuery: query });

      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      searchTimeout = setTimeout(() => {
        if (query.length >= 3) {
          // Reset data for all three results
          set((state) => ({
            oddsData: {
              odds1: [],
              odds2: [],
              odds3: [],
            },
          }));

          // Fetch data for all three markets
          const markets = [
            { market: "1,12,5", key: "odds1" },
            { market: "13,20,6", key: "odds2" },
            { market: "7,14,21", key: "odds3" },
          ];

          markets.forEach(({ market, key }) => {
            get().fetchOdds(
              market,
              key,
              `loading${key.slice(-1)}`,
              `error${key.slice(-1)}`,
              query
            );
          });
        }
      }, 500);
    },

    fetchOdds: async (
      urlOrMarket,
      oddsKey,
      loadingKey,
      errorKey,
      search = "",
      append = false
    ) => {
      set((state) => ({
        loading: { ...state.loading, [loadingKey]: true },
      }));

      try {
        let url;

        if (
          typeof urlOrMarket === "string" &&
          urlOrMarket.startsWith(`${API_URL}/api/v1/odds/`)
        ) {
          url = urlOrMarket;
        } else {
          const today = new Date().toISOString().split("T")[0];
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          const tomorrowStr = tomorrow.toISOString().split("T")[0];

          if (search.length >= 3) {
            url = `${API_URL}/api/v1/odds/?search=${encodeURIComponent(
              search
            )}`;
          } else {
            url = `${API_URL}/api/v1/odds/?market=${urlOrMarket}&fixture_date_on=${today}&fixture_date_end=${tomorrowStr}`;
          }

          set({ baseUrl: url });
        }

        const token = localStorage.getItem("token");

        let response = null;

        if (token === null) {
          response = await axios.get(url);
        } else {
          try {
            response = await axios.get(url, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
          } catch {
            // console.log('Session expired.')
            response = await axios.get(url);
          }
        }

        const data = await response.data.response;

        set((state) => ({
          oddsData: {
            ...state.oddsData,
            [oddsKey]: append
              ? [...(state.oddsData[oddsKey] || []), ...data]
              : data,
          },
          error: { ...state.error, [errorKey]: null },
        }));

        return data;
      } catch (err) {
        set((state) => ({
          error: { ...state.error, [errorKey]: err.message },
        }));
        return null;
      } finally {
        set((state) => ({
          loading: { ...state.loading, [loadingKey]: false },
        }));
      }
    },
  };
});
